import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as constants from './payment-method.constants';
import * as types from './payment-method.types';

export const storePaymentMethod = generateStoreResourceAction<types.IPaymentMethod>(constants.STORE_PAYMENT_METHOD);
export const clearPaymentMethod = generateClearResourceAction(constants.CLEAR_PAYMENT_METHOD);
